import type { ElementNode, ListNode, ParsedNode, TableNode } from "../types";

const levelList = (list: ListNode, level: number) => {
  list.level = level;
  if (list.pair) list.pair.level = level;
  list.children.forEach((li) => {
    li.level = level + 1;
    if (li.pair) li.pair.level = level + 1;
    li.children.forEach((sub) => levelList(sub, level + 2));
  });
};

const levelTable = (table: TableNode, level: number) => {
  table.level = level;
  table.rows.forEach((row) =>
    row.cells.forEach((cell) => {
      if (cell.pair) cell.pair.level = level;
    }),
  );
};

const assignLevels = (nodes: ParsedNode[], level: number) => {
  nodes.forEach((node) => {
    if (node.type === "ul" || node.type === "ol") return levelList(node as ListNode, level);
    if (node.type === "table") return levelTable(node as TableNode, level);
    node.level = level;
    if (node.type !== "text" && node.type !== "pair" && node.type !== "raw") assignLevels((node as ElementNode).children, level + 1);
  });
};

export { assignLevels };
